module.exports = require('./dist/Sticky');



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/index.js
// module id = 787
// module chunks = 156897593687669